<div class="modal-header">
  <h5 class="modal-title">{{ department.id ? 'Chỉnh Sửa Phòng Ban' : 'Thêm Phòng Ban' }}</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <label for="departmentName">
        Tên Phòng Ban
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập tên của phòng ban.<br><b>Ví Dụ:</b> Nhân Sự, CNTT, Kinh Doanh"></i>
      </label>
      <input type="text" class="form-control" id="departmentName" [(ngModel)]="department.departmentName" name="departmentName" placeholder="Ví dụ: Nhân Sự, CNTT, Kinh Doanh">
    </div>
    <div class="form-group">
      <label for="departmentCode">
        Mã Phòng Ban
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập mã duy nhất cho phòng ban.<br><b>Ví Dụ:</b> HR001, IT002"></i>
      </label>
      <input type="text" class="form-control" id="departmentCode" [(ngModel)]="department.departmentCode" name="departmentCode" placeholder="Ví dụ: HR001, IT002">
    </div>
    <div class="form-group">
      <label for="headOfDepartment">
        Trưởng Phòng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập tên của trưởng phòng.<br><b>Ví Dụ:</b> Nguyễn Văn A, Trần Thị B"></i>
      </label>
      <input type="text" class="form-control" id="headOfDepartment" [(ngModel)]="department.headOfDepartment" name="headOfDepartment" placeholder="Ví dụ: Nguyễn Văn A, Trần Thị B">
    </div>
    <div class="form-group">
      <label for="location">
        Vị Trí
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập vị trí của phòng ban.<br><b>Ví Dụ:</b> Hà Nội, TP.HCM"></i>
      </label>
      <ng-select
        name="location"
        [items]="buildings"
        bindLabel="name"
        bindValue="code"
        [(ngModel)]="department.location"
        [searchable]="true"
        placeholder="Chọn vị trí">
        <ng-template ng-label-tmp let-item="item">
          <span>{{ item.name }} {{item.code}}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span>{{item.name}} {{item.code}}</span>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-group">
      <label for="phone">
        Điện Thoại
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập số điện thoại liên hệ của phòng ban.<br><b>Ví Dụ:</b> (123) 456-7890"></i>
      </label>
      <input type="tel" class="form-control" id="phone" [(ngModel)]="department.phone" name="phone" placeholder="Ví dụ: (123) 456-7890">
    </div>
    <div class="form-group">
      <label for="countryCode">
        Mã Quốc Gia
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập mã quốc gia.<br><b>Ví Dụ:</b> VN, US, GB"></i>
      </label>
      <ng-select
        name="countryCode"
        [items]="countries"
        bindLabel="name"
        bindValue="code"
        [(ngModel)]="department.countryCode"
        [searchable]="true"
        placeholder="Chọn mã quốc gia">
        <ng-template ng-label-tmp let-item="item">
          <span>{{item.flag}} {{ item.name }} {{item.code}}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span>{{item.flag}} {{item.name}} {{item.code}}</span>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-group">
      <label for="email">
        Email
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập địa chỉ email liên hệ của phòng ban.<br><b>Ví Dụ:</b> hr@example.com"></i>
      </label>
      <input type="email" class="form-control" id="email" [(ngModel)]="department.email" name="email" placeholder="Ví dụ: hr@example.com">
    </div>
    <div class="form-group">
      <label for="numberOfEmployees">
        Số Nhân Viên
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô Tả:</b> Nhập tổng số nhân viên trong phòng ban.<br><b>Ví Dụ:</b> 50, 100"></i>
      </label>
      <input type="number" class="form-control" id="numberOfEmployees" [(ngModel)]="department.numberOfEmployees" name="numberOfEmployees" placeholder="Ví dụ: 50, 100">
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Hủy</button>
      <button type="button" class="btn btn-outline-primary" (click)="saveDepartment()">Lưu</button>
    </div>
  </form>
</div>
